import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ContactModal from './ContactModal'
import LegalAcceptanceModal from './LegalAcceptanceModal'
import { isKioskRole, useKioskRole } from '../hooks/useKioskRole'

/** Replace with your Google Forms feedback URL when ready. */
const FEEDBACK_URL = 'https://forms.gle/Zcuay4QNagXnbjRQ8'

// Use DaisyUI theme primary color, but force LTS blue in light/dark only (see `src/index.css`).
const linkClass = 'link link-hover text-primary ltsPrimaryText text-xs sm:text-sm md:text-base transition hover:underline'

type FooterProps = {
  /** Merged onto `<footer>` — use e.g. `mt-0` when footer sits in a viewport-locked flex column. */
  className?: string
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const year = new Date().getFullYear()
  const [contactModalOpen, setContactModalOpen] = useState(false)
  const [legalModalOpen, setLegalModalOpen] = useState(false)
  const kioskRole = useKioskRole()

  if (isKioskRole(kioskRole)) return null

  return (
    <>
      <footer
        className={`w-full shrink-0 bg-base-200 border-t border-base-300 pt-4 md:pt-6 pb-2 md:pb-3 px-2 md:px-0 mt-12 text-base-content ${className ?? ''}`}
      >
        <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center md:justify-between gap-x-4 gap-y-1 md:gap-y-0">
          <span className="font-semibold text-center text-xs sm:text-sm md:text-base md:text-left">© {year} Larson Tower Specialists, LLC.</span>
          <nav className="flex flex-row flex-wrap items-center justify-center gap-x-3 gap-y-1 sm:gap-x-4 md:gap-6 order-2 md:order-none">
            <Link to="/resources" className={linkClass}>Resources</Link>
            <a href={FEEDBACK_URL} target="_blank" rel="noopener noreferrer" className={linkClass}>Feedback</a>
            <button type="button" onClick={() => setContactModalOpen(true)} className={`${linkClass} bg-transparent border-none cursor-pointer p-0`}>Contact Us</button>
            <button type="button" onClick={() => setLegalModalOpen(true)} className={`${linkClass} bg-transparent border-none cursor-pointer p-0`}>Privacy Policy</button>
            <button type="button" onClick={() => setLegalModalOpen(true)} className={`${linkClass} bg-transparent border-none cursor-pointer p-0`}>Terms</button>
          </nav>
          <span className="text-[11px] sm:text-xs md:text-sm text-base-content/60 text-center md:text-right">All rights reserved.</span>
        </div>
      </footer>

      <ContactModal open={contactModalOpen} onClose={() => setContactModalOpen(false)} />

      {legalModalOpen && (
        <LegalAcceptanceModal
          tosVersion=""
          privacyVersion=""
          viewOnly
          onClose={() => setLegalModalOpen(false)}
        />
      )}
    </>
  )
}

export default Footer
